import { render, staticRenderFns } from "./salarySet.vue?vue&type=template&id=b62f7778&"
import script from "./salarySet.vue?vue&type=script&lang=js&"
export * from "./salarySet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports